module.exports = __webpack_public_path__ + "img/Image35.b244c2ed.png";